"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var eXpress;
(function (eXpress) {
    var analytics;
    (function (analytics) {
        var trackEvent = function (category, action, eventParams, value) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: action,
                event_category: category,
                event_label: JSON.stringify(eventParams),
                value: value
            });
            if (typeof gtag === 'function') {
                gtag('event', action, eventParams);
            }
            else if (typeof ga === 'function') {
                ga('technical.send', 'event', category, action, JSON.stringify(eventParams), value);
            }
        };
        function trackOrderStatusEvent(action, partialEventParams, nrOrdersInAccount, nrItemsInOrder) {
            if (nrOrdersInAccount === void 0) { nrOrdersInAccount = -1; }
            if (nrItemsInOrder === void 0) { nrItemsInOrder = -1; }
            var eventParams = __assign({ accountId: eXpress.utils.getCookie('accid') }, partialEventParams);
            trackEvent('OrderStatus', action, eventParams, nrOrdersInAccount > 0 ? nrOrdersInAccount : nrItemsInOrder);
        }
        analytics.trackOrderStatusEvent = trackOrderStatusEvent;
        function trackContactPageEvent(action) {
            trackEvent('ContactPage', action, {}, -1);
        }
        analytics.trackContactPageEvent = trackContactPageEvent;
        function trackAddressValidationEvent(action) {
            trackEvent('AddressValidation', action, {}, -1);
        }
        analytics.trackAddressValidationEvent = trackAddressValidationEvent;
        function trackMgmEvent(action) {
            trackEvent('MGMProgram', action, {}, -1);
        }
        analytics.trackMgmEvent = trackMgmEvent;
        function trackRecommendationCartEvent(action, cartRecommendationLabel) {
            trackEvent('Recommendations', action, cartRecommendationLabel ? cartRecommendationLabel : {}, -1);
        }
        analytics.trackRecommendationCartEvent = trackRecommendationCartEvent;
    })(analytics = eXpress.analytics || (eXpress.analytics = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var html;
    (function (html_1) {
        function querySelector(el, selectors, isRequired) {
            if (isRequired === void 0) { isRequired = false; }
            var resultEl = el.querySelector(selectors);
            if (isRequired && !resultEl)
                throw new Error("querySelector didn't return any results for: ".concat(selectors));
            return resultEl;
        }
        html_1.querySelector = querySelector;
        function remove(el) {
            if (el.parentElement)
                el.parentElement.removeChild(el);
        }
        html_1.remove = remove;
        function show(el) {
            if (el.offsetParent === null) {
                if (el.style.display === 'none') {
                    el.style.display = '';
                }
                else {
                    if (getComputedStyle(el).display === 'none') {
                        el.style.display = 'block';
                    }
                }
            }
        }
        html_1.show = show;
        function hide(el) {
            el.style.display = 'none';
        }
        html_1.hide = hide;
        function replaceWith(currentEl, newEl) {
            if (currentEl !== newEl && currentEl.parentNode) {
                currentEl.parentNode.replaceChild(newEl, currentEl);
            }
        }
        html_1.replaceWith = replaceWith;
        function querySelectorAll(el, selectors) {
            return el ? [].slice.call(el.querySelectorAll(selectors)) : [];
        }
        html_1.querySelectorAll = querySelectorAll;
        function getParentWithClassName(el, className) {
            if (el)
                el = el.parentElement;
            while (el) {
                if (el.classList.contains(className))
                    return el;
                el = el.parentElement;
            }
            return null;
        }
        html_1.getParentWithClassName = getParentWithClassName;
        function getParentOrSelfWithClassName(el, className) {
            if (el) {
                if (el.classList.contains(className))
                    return el;
                else
                    el = el.parentElement;
            }
            while (el) {
                if (el.classList.contains(className))
                    return el;
                el = el.parentElement;
            }
            return null;
        }
        html_1.getParentOrSelfWithClassName = getParentOrSelfWithClassName;
        function loadImageAsync(url) {
            return loadImageAsyncImpl(new Image(), url);
        }
        html_1.loadImageAsync = loadImageAsync;
        var loadImageAsyncImpl = function (image, url) {
            var deferred = $.Deferred();
            function loaded() {
                unbindEvents();
                deferred.resolve(image);
            }
            function errored() {
                unbindEvents();
                deferred.reject(image);
            }
            function tryLoadImage() {
                try {
                    image.src = url;
                }
                catch (e) {
                    deferred.reject();
                }
            }
            function unbindEvents() {
                image.onload = image.onerror = image.onabort = null;
            }
            image.onload = loaded;
            image.onerror = errored;
            image.onabort = errored;
            tryLoadImage();
            return deferred;
        };
        function addEventListener(element, type, listener, useCapture) {
            var disposable = {
                dispose: function () {
                    if (disposable.handler) {
                        element.removeEventListener(disposable.type, disposable.handler, useCapture);
                        delete disposable.handler;
                    }
                },
                handler: function (ev) {
                    return listener(ev);
                },
                type: type
            };
            element.addEventListener(disposable.type, disposable.handler, useCapture);
            return disposable;
        }
        html_1.addEventListener = addEventListener;
        function disableUserEvents() {
            var eventsToBlock = ["click", "keydown", "keyup", "mouseenter", "mouseleave", "focus"];
            var disposable = {
                blockingEvents: eventsToBlock.map(function (event) { return addEventListener(window, event, function (e) { return blockEvent(e); }, true); }),
                dispose: function () {
                    if (disposable.blockingEvents) {
                        disposable.blockingEvents.forEach(function (blockedEvent) { return blockedEvent.dispose(); });
                    }
                }
            };
            return disposable;
        }
        html_1.disableUserEvents = disableUserEvents;
        var blockEvent = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        function addClass(element, cssClass) {
            toggleClass(element, cssClass, true);
        }
        html_1.addClass = addClass;
        function removeClass(element, cssClass) {
            toggleClass(element, cssClass, false);
        }
        html_1.removeClass = removeClass;
        function toggleClass(element, cssClass, on) {
            var regex = new RegExp('(?:^|\\s)' + cssClass + '(?!\\S)');
            var hasClass = element.className.match(regex);
            if (hasClass && !on) {
                element.className = element.className.replace(new RegExp(regex.source, "g"), '');
            }
            else if (!hasClass && on) {
                element.className += " " + cssClass;
            }
        }
        html_1.toggleClass = toggleClass;
        function hasClass(element, cssClass) {
            var regex = new RegExp('(?:^|\\s)' + cssClass + '(?!\\S)');
            var match = element.className.match(regex);
            return !!match && !!match.length;
        }
        html_1.hasClass = hasClass;
        function getWindowSize() {
            var w = window;
            var d = document;
            var e = d.documentElement;
            var g = d.body;
            var x = w.innerWidth || e.clientWidth || g.clientWidth;
            var y = w.innerHeight || e.clientHeight || g.clientHeight;
            return { width: x, height: y };
        }
        html_1.getWindowSize = getWindowSize;
        function isElementVisible(el) {
            return !(el.offsetWidth
                + el.offsetHeight
                + el.getBoundingClientRect().height
                + el.getBoundingClientRect().width === 0);
        }
        html_1.isElementVisible = isElementVisible;
        function fixBackButton() {
            window.onunload = function () {
            };
        }
        html_1.fixBackButton = fixBackButton;
        function getHeightWithMargins(el) {
            return el.getBoundingClientRect().height
                + parseInt(window.getComputedStyle(el).marginTop || "0", 10)
                + parseInt(window.getComputedStyle(el).marginBottom || "0", 10);
        }
        html_1.getHeightWithMargins = getHeightWithMargins;
        function getWidthWithMargins(el) {
            return el.getBoundingClientRect().width
                + parseInt(window.getComputedStyle(el).marginLeft || "0", 10)
                + parseInt(window.getComputedStyle(el).marginRight || "0", 10);
        }
        html_1.getWidthWithMargins = getWidthWithMargins;
        var inViewArray;
        function inViewTrigger(element, callBack) {
            var inViewScrollHandler = function () {
                for (var i = inViewArray.length - 1; i >= 0; i--) {
                    var _a = inViewArray[i], element_1 = _a.element, callBack_1 = _a.callBack;
                    var windowHeight = window.innerHeight;
                    var scrollY_1 = window.scrollY || window.pageYOffset;
                    var scrollPosition = scrollY_1 + windowHeight;
                    var elementHeight = element_1.clientHeight;
                    var elementPosition = element_1.getBoundingClientRect().top + scrollY_1 + elementHeight;
                    if (scrollPosition > elementPosition) {
                        callBack_1(element_1);
                        inViewArray.splice(i, 1);
                    }
                }
                if (inViewArray.length === 0) {
                    document.removeEventListener('scroll', inViewScrollHandler);
                }
            };
            if (!inViewArray || inViewArray.length === 0) {
                inViewArray = [];
                document.addEventListener('scroll', inViewScrollHandler);
            }
            inViewArray.push({ element: element, callBack: callBack });
            inViewScrollHandler();
        }
        html_1.inViewTrigger = inViewTrigger;
        function isMobileOnPageWithHeader() {
            return html.isElementVisible(html.querySelector(document, '.o-main-navigation__hamburger-button', true));
        }
        html_1.isMobileOnPageWithHeader = isMobileOnPageWithHeader;
        function isMobile() {
            return (window.innerWidth <= 960 && window.innerHeight <= 960);
        }
        html_1.isMobile = isMobile;
        function htmlToElement(html) {
            var template = document.createElement('template');
            html = html.trim();
            template.innerHTML = html;
            return template.content.firstChild;
        }
        html_1.htmlToElement = htmlToElement;
    })(html = eXpress.html || (eXpress.html = {}));
})(eXpress || (eXpress = {}));
if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function (name, force) {
        if (force !== void 0)
            force = !!force;
        if (this.hasAttribute(name)) {
            if (force)
                return true;
            this.removeAttribute(name);
            return false;
        }
        if (force === false)
            return false;
        this.setAttribute(name, "");
        return true;
    };
}
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s))
                return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
(function (arr) {
    arr.forEach(function (item) {
        if (Object.prototype.hasOwnProperty.call(item, 'append')) {
            return;
        }
        Object.defineProperty(item, 'append', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function append() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var docFrag = document.createDocumentFragment();
                args.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });
                this.appendChild(docFrag);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function isAuthenticationCheck(accountId) {
            var emptyGuid = '00000000-0000-0000-0000-000000000000';
            var isStillAtuhenticated = true;
            if (!accountId)
                isStillAtuhenticated = false;
            if (accountId === emptyGuid)
                isStillAtuhenticated = false;
            return isStillAtuhenticated;
        }
        utils.isAuthenticationCheck = isAuthenticationCheck;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getCookie(cName) {
            var allCookies = document.cookie;
            if (allCookies.length > 0) {
                var cStart = allCookies.indexOf(cName + "=");
                if (cStart !== -1) {
                    cStart = cStart + cName.length + 1;
                    var cEnd = allCookies.indexOf(";", cStart);
                    if (cEnd === -1)
                        cEnd = allCookies.length;
                    return unescape(allCookies.substring(cStart, cEnd));
                }
            }
            return "";
        }
        utils.getCookie = getCookie;
        function writeCookie(cName, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cName + "=" + cvalue + ";" + expires + "; path=/";
        }
        utils.writeCookie = writeCookie;
        function writeCookieThatExpiresAtTheEndOfTheDay(cName, cValue) {
            var d = new Date();
            var midnight = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
            var expires = "expires=" + midnight.toUTCString();
            document.cookie = encodeURIComponent(cName) + "=" + encodeURIComponent(cValue) + ";" + expires + "; path=/";
        }
        utils.writeCookieThatExpiresAtTheEndOfTheDay = writeCookieThatExpiresAtTheEndOfTheDay;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        var countryCodes = {
            'aut': '+43',
            'bel': '+32',
            'deu': '+49',
            'dnk': '+45',
            'che': '+41',
            'fin': '+358',
            'fra': '+33',
            'gbr': '+44',
            'irl': '+353',
            'lux': '+352',
            'nld': '+31',
            'nor': '+47',
            'swe': '+46'
        };
        function FillPhoneWithCountryPrefixWhenEmpty(countrycode) {
            var _a;
            return !countrycode ? '' : (_a = countryCodes[countrycode.toLowerCase()]) !== null && _a !== void 0 ? _a : '';
        }
        utils.FillPhoneWithCountryPrefixWhenEmpty = FillPhoneWithCountryPrefixWhenEmpty;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function debounce(fn, delay) {
            var timeoutID = 0;
            var callable = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                clearTimeout(timeoutID);
                timeoutID = window.setTimeout(function () { return fn.apply(args); }, delay);
            };
            return callable;
        }
        utils.debounce = debounce;
        function throttle(fn, delay) {
            var lastTimestamp = 0;
            var callable = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var now = Date.now();
                if (!lastTimestamp || now - lastTimestamp >= delay) {
                    lastTimestamp = now;
                    fn.apply(void 0, args);
                }
            };
            return callable;
        }
        utils.throttle = throttle;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function isTouchDevice() {
            var result = false;
            if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
                if (navigator.maxTouchPoints > 0) {
                    result = true;
                }
            }
            else {
                if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
                    result = true;
                }
                else if (window.TouchEvent || ('ontouchstart' in window)) {
                    result = true;
                }
            }
            return result;
        }
        utils.isTouchDevice = isTouchDevice;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function compositeDisposable(disposables) {
            var composite = {
                dispose: function () {
                    if (composite) {
                        composite = null;
                        if (disposables)
                            disposables.forEach(function (d) { return d.dispose(); });
                    }
                },
                add: function (addDisposables) {
                    if (!disposables)
                        disposables = [];
                    disposables.push.apply(disposables, addDisposables);
                }
            };
            return composite;
        }
        utils.compositeDisposable = compositeDisposable;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getGuid() {
            var d = new Date().getTime();
            var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16;
                if (d > 0) {
                    r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                }
                else {
                    r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }
        utils.getGuid = getGuid;
        function newSliderGuid() {
            return 'sxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
        utils.newSliderGuid = newSliderGuid;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        var getInlineSvgAsync = function (url) {
            var deferred = $.Deferred();
            $.ajax(url, { dataType: 'xml' })
                .then(function (data) {
                var document = data;
                if (document && document.documentElement.nodeName.toLowerCase() === 'svg') {
                    var svgString = new XMLSerializer().serializeToString(document);
                    deferred.resolve({
                        url: url,
                        svg: svgString
                    });
                }
                else {
                    deferred.resolve(undefined);
                }
            }, function (jqXhr, status, error) {
                if (window && window.onerror)
                    window.onerror("Icon not found on : ".concat(url, " , ").concat(status.indexOf('parser') !== -1 ? "not an icon" : status));
                deferred.resolve(undefined);
            });
            return deferred.promise();
        };
        function getInlineSvgsAsync(urls) {
            return utils.whenAll(urls.map(function (u) { return getInlineSvgAsync(u); }))
                .then(function (items) { return items.filter(function (item) { return !!item; }); });
        }
        utils.getInlineSvgsAsync = getInlineSvgsAsync;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function showLoadingDialog(promise, timeToShowLoadingDialog, extraTimeOutAfterResolving, timeoutToDisableLoadingDialog) {
            if (timeToShowLoadingDialog === void 0) { timeToShowLoadingDialog = 200; }
            var htmlEl = eXpress.html.querySelector(document, "html", true);
            var bodyEl = eXpress.html.querySelector(document, "body", true);
            var dialogEl = eXpress.html.querySelector(bodyEl, ".technical-loading-dialog", true);
            htmlEl.style.top = -(document.documentElement.scrollTop) + 'px';
            bodyEl.style.top = -(document.documentElement.scrollTop) + 'px';
            var toggleClasses = function (show) {
                eXpress.html.toggleClass(dialogEl, "u-hide", !show);
            };
            var show = setTimeout(function () { return toggleClasses(true); }, timeToShowLoadingDialog);
            var blockingEventDisposables = eXpress.html.disableUserEvents();
            var manualTimeoutToDisableLoadingDialog;
            var disableLoadingDialog = function () {
                clearTimeout(show);
                if (manualTimeoutToDisableLoadingDialog)
                    clearInterval(manualTimeoutToDisableLoadingDialog);
                blockingEventDisposables.dispose();
                htmlEl.style.top = '';
                bodyEl.style.top = '';
                toggleClasses(false);
            };
            if (timeoutToDisableLoadingDialog)
                manualTimeoutToDisableLoadingDialog = setInterval(function () { return disableLoadingDialog(); }, timeoutToDisableLoadingDialog);
            return promise.done(function () {
                if (extraTimeOutAfterResolving)
                    setTimeout(function () { return disableLoadingDialog(); }, extraTimeOutAfterResolving);
                else
                    disableLoadingDialog();
            });
        }
        utils.showLoadingDialog = showLoadingDialog;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function calculateAndSetHeightOfMobileNavigationLevel(mobileNavigationLevel) {
            mobileNavigationLevel.style.height = '100vh';
            var browserUiBars = mobileNavigationLevel.getBoundingClientRect().height - window.innerHeight;
            var menuItemsLvlPositionTop = document.body.getBoundingClientRect().top - mobileNavigationLevel.getBoundingClientRect().top;
            mobileNavigationLevel.style.height = 'calc(100vh - ' + Math.abs(browserUiBars) + 'px + ' + menuItemsLvlPositionTop + 'px)';
        }
        utils.calculateAndSetHeightOfMobileNavigationLevel = calculateAndSetHeightOfMobileNavigationLevel;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function checkPersonalNumber(pin, regionCode) {
            if (pin.trim() === "")
                return true;
            switch (regionCode) {
                case "SWE":
                    return checksumSe(pin);
                case "NOR":
                    return checksumNo(pin);
                case "DNK":
                    return checksumDk(pin);
                case "FIN":
                    return checksumFi(pin);
                default:
                    return true;
            }
        }
        utils.checkPersonalNumber = checkPersonalNumber;
        var checksumDk = function (pin) {
            if (pin && pin.length === 11) {
                var checkSumString = "4327654321";
                var result1 = 0;
                var temp = pin.toString().substring(0, 6) + pin.toString().substring(7, 10);
                for (var i = 0; i < 9; i++) {
                    result1 += parseInt(checkSumString[i].toString(), 10) * parseInt(temp[i].toString(), 10);
                }
                var checksum = 11 - result1 % 11;
                if (checksum === 11)
                    checksum = 0;
                if (checksum.toString() === pin[10])
                    return true;
                else
                    return false;
            }
            else {
                return false;
            }
        };
        var checksumFi = function (pin) {
            if (pin && pin.length === 11) {
                var checkSumString = "0123456789ABCDEFHJKLMNPRSTUVWXY";
                var temp = parseInt(pin.toString().substring(0, 6) + pin.toString().substring(7, 10), 10);
                var result1 = temp % 31;
                var checksum = checkSumString[result1];
                if (checksum === pin[10])
                    return true;
                else
                    return false;
            }
            else {
                return false;
            }
        };
        var checksumNo = function (pin) {
            if (pin && pin.length === 12) {
                var result1 = 0;
                var result2 = 0;
                var checkSumString1 = "376189-452";
                var checkSumString2 = "543276-5432";
                for (var i = 0; i < 10; i++) {
                    if (i === 6)
                        continue;
                    result1 += parseInt(checkSumString1[i].toString(), 10) * parseInt(pin[i].toString(), 10);
                }
                var checksum1 = 11 - result1 % 11;
                if (checksum1 === 11)
                    checksum1 = 0;
                if (checksum1.toString() !== pin[10])
                    return false;
                for (var i = 0; i < 11; i++) {
                    if (i === 6)
                        continue;
                    result2 += parseInt(checkSumString2[i].toString(), 10) * parseInt(pin[i].toString(), 10);
                }
                var checksum2 = 11 - result2 % 11;
                if (checksum2 === 11)
                    checksum2 = 0;
                if (checksum2.toString() !== pin[11])
                    return false;
                else
                    return true;
            }
            else {
                return false;
            }
        };
        var checksumSe = function (pin) {
            var orignalPin = pin;
            if (!pin || pin.length !== 13)
                return false;
            var result1 = 0;
            var multiplier = "212121-212".split('').map(function (s) { return +s; });
            var temp = 0;
            if (pin.length === 13)
                pin = pin.toString().substring(2);
            var pins = pin.split('').map(function (s) { return +s; });
            for (var i = 0; i < 10; i++) {
                if (i === 6)
                    continue;
                temp = multiplier[i] * pins[i];
                if (temp > 9)
                    result1 += parseInt(temp.toString().split('')[0], 10) + parseInt(temp.toString().split('')[1], 10);
                else
                    result1 += temp;
            }
            var lastDigit = parseInt(result1.toString().split('')[result1.toString().length - 1], 10);
            var checksum;
            if (lastDigit === 0)
                checksum = 0;
            else
                checksum = 10 - lastDigit;
            if (checksum === pins[10])
                return birthdaySe(orignalPin);
            else
                return false;
        };
        var birthdaySe = function (pin) {
            var regExp = new RegExp(/^(?:((?:19|20)?\d\d))([01]\d)(\d\d)([-+]?)(\d\d|TF)(\d)(\d)$/);
            var result = regExp.test(pin);
            return result;
        };
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getPriceString(amount, setup) {
            var result = '';
            if (setup.displayLeftToPrice)
                result += setup.currencySymbol + ' ';
            result += amount.toFixed(2).replace('.', setup.decimalSeparator);
            if (!setup.displayLeftToPrice)
                result += ' ' + setup.currencySymbol;
            return result;
        }
        utils.getPriceString = getPriceString;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function whenAll(promises) {
            return $.when.apply($, promises).then(function () {
                var items = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    items[_i] = arguments[_i];
                }
                return items;
            });
        }
        utils.whenAll = whenAll;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getFullQuerystring(url) {
            url = url || window.location.href;
            var pos = url.indexOf("?");
            if (pos > -1) {
                return url.substring(pos + 1);
            }
            else {
                return url;
            }
        }
        utils.getFullQuerystring = getFullQuerystring;
        function getParameters(url) {
            var queryString = eXpress.utils.getFullQuerystring(url);
            var pairs = queryString.split('#')[0].split("&");
            var params = {};
            for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
                var pair = pairs_1[_i];
                var _a = pair.split("="), key = _a[0], value = _a[1];
                params[key.toLowerCase()] = value !== undefined ? value : "true";
            }
            return params;
        }
        utils.getParameters = getParameters;
        function getParameter(key, url, required) {
            if (required === void 0) { required = false; }
            var queryStringParam = eXpress.utils.getParameters(url)[key.toLowerCase()];
            if (required && !queryStringParam)
                throw new Error("No queryStringParam for Required key: ".concat(key));
            return queryStringParam;
        }
        utils.getParameter = getParameter;
        function updateParameter(key, value, url) {
            url = url || window.location.href;
            var newAdditionalURL = "";
            var tempArray = url.split("#");
            var hash = tempArray[1] ? tempArray[1] : '';
            var additionalURL = tempArray[0] ? tempArray[0].split("?")[1] : '';
            var baseURL = tempArray[0] ? tempArray[0].split("?")[0] : '';
            var temp = "";
            if (additionalURL) {
                tempArray = additionalURL.split("&");
                for (var i = 0; i < tempArray.length; i++) {
                    if (tempArray[i].split('=')[0] !== key) {
                        newAdditionalURL += temp + tempArray[i];
                        temp = "&";
                    }
                }
            }
            var result = temp;
            if (value)
                result += "" + key + "=" + value;
            else
                result = result.substring(0, result.length - 1);
            if (!newAdditionalURL && !result)
                return baseURL + (hash ? '#' + hash : '');
            return baseURL + "?" + newAdditionalURL + result + (hash ? '#' + hash : '');
        }
        utils.updateParameter = updateParameter;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function resolveVersionedUrlCdn(path, file) {
            var context = window.context;
            if (!context)
                return path + file;
            if (context.versionedStaticPaths === "true")
                return context.cdn + path + context.revision + '/' + file;
            return context.cdn + path + file + ((context.revision) ? '?' + context.revision : '');
        }
        utils.resolveVersionedUrlCdn = resolveVersionedUrlCdn;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function capitalizeFirstLetterOfWords(input) {
            var words = input.split(" ");
            for (var i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
            }
            return words.join(" ");
        }
        utils.capitalizeFirstLetterOfWords = capitalizeFirstLetterOfWords;
        function onlyLetters(input) {
            return Boolean(input.match(/^[A-Za-z]*$/));
        }
        utils.onlyLetters = onlyLetters;
        function onlyNumber(input) {
            return Boolean(input.match(/^[0-9]*$/));
        }
        utils.onlyNumber = onlyNumber;
        function stringToBase64(inputString) {
            var bytes = new TextEncoder().encode(inputString);
            var binString = Array.from(bytes, function (byte) {
                return String.fromCodePoint(byte);
            }).join("");
            return window.btoa(binString);
        }
        utils.stringToBase64 = stringToBase64;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function isValidNumberAfterKeyPress(event, min, max) {
            var keyNr = event.keyCode || event.which;
            if (keyNr !== 8 && keyNr !== 9 && keyNr !== 13 && keyNr !== 16 && keyNr !== 17 && keyNr !== 18) {
                var key = String.fromCharCode(keyNr);
                var newValue = void 0;
                var textbox = event.target;
                if (!textbox.selectionStart && !textbox.selectionEnd) {
                    newValue = textbox.value + key;
                }
                else {
                    var val1 = textbox.value.substr(0, (textbox.selectionStart || 0));
                    var val2 = textbox.value.substr(textbox.selectionEnd || 0);
                    newValue = val1 + key + val2;
                }
                var regex = new RegExp("[^0-9]", 'g');
                var intValue = parseInt(newValue, 10);
                if (newValue.match(regex) || isNaN(intValue) || intValue > max || intValue < min) {
                    event.returnValue = false;
                    if (event.preventDefault)
                        event.preventDefault();
                    return false;
                }
            }
            return true;
        }
        utils.isValidNumberAfterKeyPress = isValidNumberAfterKeyPress;
        function doGetCaretPosition(ctrl) {
            var caretPos = 0;
            if (ctrl.selectionStart || ctrl.selectionStart === 0) {
                caretPos = ctrl.selectionStart;
            }
            return caretPos;
        }
        utils.doGetCaretPosition = doGetCaretPosition;
        function isValidTextWithoutAngleBrackets(text) {
            if (!text)
                return false;
            return new RegExp("^[^<>]+$").test(text);
        }
        utils.isValidTextWithoutAngleBrackets = isValidTextWithoutAngleBrackets;
        function setCaretPosition(ctrl, pos) {
            if (ctrl.setSelectionRange) {
                ctrl.focus();
                ctrl.setSelectionRange(pos, pos);
            }
        }
        utils.setCaretPosition = setCaretPosition;
        function vatNumberHasCorrectCountryCode(vatNumber, countryCode) {
            if (countryCode.toLowerCase() !== 'bel'
                && countryCode.toLowerCase() !== 'ndl'
                && countryCode.toLowerCase() !== 'che'
                && countryCode.toLowerCase() !== 'swe')
                return true;
            var testVal = '';
            switch (countryCode.toLowerCase()) {
                case 'bel':
                    testVal = vatNumber.substring(0, 2);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'be');
                    break;
                case 'ndl':
                    testVal = vatNumber.substring(0, 2);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'nl');
                    break;
                case 'che':
                    testVal = vatNumber.substring(0, 3);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'che');
                    break;
                case 'swe':
                    testVal = vatNumber.substring(0, 2);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'se');
                    break;
            }
        }
        utils.vatNumberHasCorrectCountryCode = vatNumberHasCorrectCountryCode;
        function isValidVatNumber(input, countryCode) {
            if (vatNumberHasCorrectCountryCode(input, countryCode)) {
                if (countryCode.toLowerCase() !== 'bel')
                    return true;
                var vatNumber = input.match(/\d/g);
                var vatNumberString = '';
                if (vatNumber)
                    vatNumberString = vatNumber.join('');
                var part1 = parseInt(vatNumberString.substring(0, vatNumberString.length - 2), 10);
                var part2 = parseInt(vatNumberString.substring(vatNumberString.length - 2), 10);
                var temp = part1 - parseInt((part1 / 97) + "", 10) * 97;
                return 97 - temp === part2;
            }
            return false;
        }
        utils.isValidVatNumber = isValidVatNumber;
        function isValidWithoutNonAlphaNumericCharsAtEnd(text, el) {
            var reg = new RegExp('^[\\p{L}\\p{N}]*$', 'u');
            var elName = el.getAttribute("name") || "";
            var alsoAlsoAllowBracket = elName && elName.toLowerCase().indexOf('city') !== -1;
            var last = text.trim().charAt(text.trim().length - 1);
            return reg.test(last) || (alsoAlsoAllowBracket && last === ')') || last === '.';
        }
        utils.isValidWithoutNonAlphaNumericCharsAtEnd = isValidWithoutNonAlphaNumericCharsAtEnd;
        function isValidEmailAddress(email) {
            var sValidEmail = '^((([a-zA-Z]|\\d|!|#|\\$|\\[|\\]|%|&|\'|\\\\|\\/|\\+|\\-|=|\\?|\\^|\\*|_|{|}|`|\\||~)+(\\.([a-zA-Z]|\\d|!|#|\\$|\\[|\\]|%|&|\'|\\\\|\\/|\\+|\\-|=|\\?|\\^|\\*|_|{|}|`|\\||~)+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e])|(\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-zA-Z]|\\d)|(([a-zA-Z]|\\d)([a-zA-Z]|\\d|-|\\.|_|~)*([a-zA-Z]|\\d)))\\\.)+(([a-zA-Z])|(([a-zA-Z])([a-zA-Z]|\\d|-|\\.|_|~)*([a-zA-Z])))$';
            var reValidEmail = new RegExp(sValidEmail);
            return reValidEmail.test(punycode.toUnicode(email));
        }
        utils.isValidEmailAddress = isValidEmailAddress;
        function isValidOrderNumber(orderNr) {
            return utils.onlyNumber(orderNr) && orderNr.length === 14;
        }
        utils.isValidOrderNumber = isValidOrderNumber;
        function canNotContainOnlyNumerics(text) {
            var reg = new RegExp('^[0-9]+$');
            return !reg.test(text);
        }
        utils.canNotContainOnlyNumerics = canNotContainOnlyNumerics;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function wait(delay) {
            if (delay === void 0) { delay = 0; }
            var deferred = $.Deferred();
            setTimeout(function () { return deferred.resolve(); }, delay);
            return deferred.promise();
        }
        utils.wait = wait;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
